import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import SignInPage from './SignInPage';

const SignInRoute: FuseRouteItemType = {
  path: '',
  element: <SignInPage />,
  auth: AUTH_ROLES.onlyGuest, // []
};

export default SignInRoute;
